var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7H8.75M7.58333 4.08333C7.58333 4.70217 7.3375 5.29566 6.89992 5.73325C6.46233 6.17083 5.86884 6.41667 5.25 6.41667C4.63116 6.41667 4.03767 6.17083 3.60008 5.73325C3.1625 5.29566 2.91667 4.70217 2.91667 4.08333C2.91667 3.46449 3.1625 2.871 3.60008 2.43342C4.03767 1.99583 4.63116 1.75 5.25 1.75C5.86884 1.75 6.46233 1.99583 6.89992 2.43342C7.3375 2.871 7.58333 3.46449 7.58333 4.08333ZM5.25 8.16667C4.32174 8.16667 3.4315 8.53542 2.77513 9.19179C2.11875 9.84817 1.75 10.7384 1.75 11.6667V12.25H8.75V11.6667C8.75 10.7384 8.38125 9.84817 7.72487 9.19179C7.0685 8.53542 6.17826 8.16667 5.25 8.16667Z",
    stroke: "#3F3F46",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5V9",
    stroke: "#3F3F46",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.4741ba86d9884bf757eb96f34bf214fa.svg";
export { ForwardRef as ReactComponent };